"use client"

import clsx from 'clsx'
import { ptMap, pbMap } from '@lib/token-maps'
import { init, Form } from '@feathery/react';
import { type ComponentPropsWithoutRef, useState, useEffect } from 'react'
import Container from '@components/container'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'
import { Icon, Button } from '@shc/ui'

export interface FeatheryFormProps extends ComponentPropsWithoutRef<'div'> {
    formTitle: string
    SDKKey: string
    formId: string
    displayType: string
    formCompleteUrl: string | undefined
    paddingTop: "0px" | "20px" | "40px" | "48px" | "60px";
    paddingBottom: "0px" | "20px" | "40px" | "48px" | "60px";
    initialValues: any
}

const FeatheryForm = ({ formTitle, SDKKey, formId, displayType, formCompleteUrl, paddingTop, paddingBottom, initialValues }: FeatheryFormProps) => {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [formCompleted, setFormCompleted] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const popupOpts = displayType === 'Popup' ? { show: showPopup, onHide: () => setShowPopup(false) } : undefined;
    const hidePrepopulatedFields = pathname.startsWith('/providers/contact-us');

    const firstname = searchParams.get('firstname');
    const lastname = searchParams.get('lastname');
    const email = searchParams.get('email');

    let prepopulatedValues = {...initialValues};

    if(firstname || lastname || email){
        prepopulatedValues = {...prepopulatedValues, scmg_name_first: firstname, scmg_name_last: lastname, scmg_email: email};
    }

    // Initialize Feathery
    init(SDKKey);
    useEffect(() => {
        if( formCompleted ){
            router.push(formCompleteUrl || '/thank-you' );
        }
    },[formCompleted, formCompleteUrl, router]);

    const loaderIcon = (
        <div className={'col-span-12 flex flex-col md:flex-row w-full justify-center'}>
            <Icon
                color="#42484d"
                icon="spinner-third"
                size="2x"
                spin
            />
        </div>
    );

    // Show the Feathery form
    return (
        <Container className={clsx('grid grid-cols-12', ptMap[paddingTop], pbMap[paddingBottom])}>
            <div className={'col-span-12 flex flex-col md:flex-row w-full feathery-form'}>
                { displayType === 'Popup' && (
                    <Button
                        id="feathery-form-cta"
                        aria-label=""
                        color="primary"
                        shape="rounded"
                        variant='filled'
                        size="sm"
                        width="auto"
                        onClick={() => setShowPopup(true)}
                        >
                        {formTitle}
                    </Button>
                )}
                { showLoader && loaderIcon }
                <Form 
                    formId={formId}
                    onFormComplete={() => setFormCompleted(true)}
                    onLoad={(context) => {
                        context.setFieldValues(prepopulatedValues);
                        if(hidePrepopulatedFields){
                            Object.keys(prepopulatedValues).forEach((k) => {
                                context.fields[k].setStyles({ 'visibility': 'hidden'})
                            })
                        }
                        setShowLoader(false);
                    }}
                    className={'feathery-form'}
                    popupOptions={popupOpts}
                />
            </div> 
        </Container>
    )
}

export default FeatheryForm


